import _ from 'lodash'
import axios from 'axios'
import pAll from 'p-all'

class GlobalDataService {
  constructor () {
    this.resourceList = [
      'translations'
    ]
  }

  async init () {
    await pAll(_.map(this.resourceList, key => {
      return async () => {
        try {
          const { data } = await axios.get(`/api/${key}.json`)
          _.set(this, key, data)
        } catch (error) {
          console.error(error)
        }
      }
    }), { concurrency: 1 })
  }
}

export default new GlobalDataService()
